import { createSlice } from '@reduxjs/toolkit';

import { INIT_DATA_ACCESS_CODE, INIT_DATA_RECORDED } from 'constants/default';
import { logout } from '../auth';

const initialState = {
  recorded: INIT_DATA_RECORDED,
  accessCode: INIT_DATA_ACCESS_CODE,
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openRecorded: (state, action) => {
      state.recorded = {
        isOpen: true,
        ...action.payload,
      };
    },
    closeRecorded: (state, action) => {
      state.recorded = INIT_DATA_RECORDED;
    },
    openAccessCode: (state, action) => {
      state.accessCode = {
        isOpen: true,
        eventId: action.payload,
      };
    },
    closeAccessCode: (state, action) => {
      state.accessCode = INIT_DATA_ACCESS_CODE;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const getRecorded = (state) => state.modal.recorded;

export const getAccessCode = (state) => state.modal.accessCode;

export const { openRecorded, closeRecorded, openAccessCode, closeAccessCode } =
  modalSlice.actions;

export default modalSlice.reducer;
